import { MODULE } from "./materials.actionTypes";
export const materialsSelector = (state) => {
  return state.getIn([MODULE, "materials"]);
};
